/** The available modules. Future modules register here (or via a remote registry). */
import type { AffectModule, CreateModule } from '../core/module-api';
import type { ShapeLibrary } from '../core/shape-library';
import { createShapes } from './create/shapes';
import { createSpeed } from './create/speed';
import { createPressure } from './create/pressure';
import { createMic } from './create/mic';
import { createPitch } from './create/pitch';
import { createRibbon } from './create/ribbon';
import { createStamp } from './create/stamp';
import { createTrace } from './create/trace';
import { createType } from './create/type';
import { createPull } from './create/pull';
import { createScrawl } from './create/scrawl';
import { createSplatter } from './create/splatter';
import { createXShapes } from './create/xshapes';
import { createEvolveShapes } from './create/evolveshapes';
import { createInverseShapes } from './create/inverseshapes';
import { createMedianShapes } from './create/medianshapes';
import { createDetachShapes } from './create/detachshapes';
import { createMirror } from './affect/mirror';
import { createRepeat } from './affect/repeat';
import { createSmooth } from './affect/smooth';
import { createRandom } from './affect/random';
import { createColorSwitcher } from './affect/colorswitcher';
import { createGradient } from './affect/gradient';
import { createDisplace } from './affect/displace';
import { createLimit } from './affect/limit';
import { createBlindness } from './affect/blindness';
import { createShapeSwap } from './affect/shapeswap';
import { createMicExpand } from './affect/micexpand';

export function createModules(lib: ShapeLibrary): CreateModule[] {
  return [
    createShapes(),
    createSpeed(),
    createPressure(),
    createMic(),
    createPitch(),
    createType(),
    createRibbon(),
    createStamp(lib),
    createTrace(),
    createPull(),
    createScrawl(),
    createSplatter(),
    createXShapes(),
    createEvolveShapes(),
    createInverseShapes(),
    createMedianShapes(),
    createDetachShapes(),
  ];
}

export function affectModules(): AffectModule[] {
  return [
    createMirror(),
    createRepeat(),
    createSmooth(),
    createRandom(),
    createColorSwitcher(),
    createGradient(),
    createDisplace(),
    createLimit(),
    createBlindness(),
    createShapeSwap(),
    createMicExpand(),
  ];
}
